import { render, staticRenderFns } from "./_PageSubMenuUncompleted.vue?vue&type=template&id=0cbf8bae&"
import script from "./_PageSubMenuUncompleted.vue?vue&type=script&lang=js&"
export * from "./_PageSubMenuUncompleted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports